// extracted by mini-css-extract-plugin
export default {"formTitle":"FormHeader_formTitle__9NF-i","alert":"FormHeader_alert__K+vLJ","alertDanger":"FormHeader_alertDanger__5JnyQ"};